module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.outsideClick),
      expression: "outsideClick"
    }],
    staticClass: "dot-navigation"
  }, [(_vm.items.length > 0) ? _c('div', {
    staticClass: "dot-navigation--trigger icon icon-more-vertical1",
    on: {
      "click": _vm.toggleVisible
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "dot-navigation--content"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.name,
      staticClass: "dot-navigation--content-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.name
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.outsideClick($event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e105d06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/DotNavigation.vue
// module id = 1921
// module chunks = 0